import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { payByLink } from "../lib/api";
import Seo from "../components/Seo";
import { Loader2, XCircle } from "lucide-react";

export default function PayLink() {
  const { orderId } = useParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!orderId) return;
    payByLink(orderId).then(({ url, fields }) => {
      const f = document.createElement("form");
      f.method = "POST";
      f.action = url;
      Object.entries(fields).forEach(([n, v]) => {
        const inp = document.createElement("input");
        inp.type = "hidden"; inp.name = n; inp.value = v;
        f.appendChild(inp);
      });
      document.body.appendChild(f);
      f.submit();
    }).catch((err) => setError(err.response?.data?.detail || "No se pudo iniciar el pago"));
  }, [orderId]);

  return (
    <div className="max-w-lg mx-auto px-4 py-20 text-center" data-testid="pay-link-page">
      <Seo title="Pago del pedido | FABRIPAN" description="Complete el pago de su pedido." noindex />
      {error ? (
        <>
          <XCircle className="h-14 w-14 text-red-500 mx-auto mb-4" />
          <h1 className="font-heading font-bold text-2xl tracking-tighter mb-2">No se pudo iniciar el pago</h1>
          <p className="text-muted-foreground mb-6">{error}</p>
          <Link to="/tienda" className="border border-border rounded-sm px-5 py-2.5 text-sm hover:border-brand">Volver a la tienda</Link>
        </>
      ) : (
        <>
          <Loader2 className="h-10 w-10 text-brand mx-auto mb-4 animate-spin" />
          <p className="text-muted-foreground">Redirigiendo a la pasarela de pago segura…</p>
        </>
      )}
    </div>
  );
}
